<div class="mainContainer">
  <div class="span">
    <div class="filter_show">
      <h2 class="log_track">Log Tracking</h2>
    </div>
    <div class="filter_hide" (click)="setDate()">
      <i class="fa fa-filter flt" ></i>
      <p class="set_date">Filter</p>
    </div>
  </div>

  <div class="content" style="width: 100%; height: 80%;">
    <ag-grid-angular style="width: 100%; height: 500px;" class="ag-theme-alpine" [rowData]="rowData"
      [columnDefs]="colDefs" [defaultColDef]="defaultColDef" [autoGroupColumnDef]="autoGroupColumnDef"
      [rowGroupPanelShow]="rowGroupPanelShow" (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </div>
</div>

<!-- loading -->
<ngx-spinner class="spinner" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>